// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__eyf_k","icon":"SortAdornment_icon__tgV77","up":"SortAdornment_up__1Nf-a","down":"SortAdornment_down__2EMVK","active":"SortAdornment_active__21XUQ"};